import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginAdmin } from "./authApi";

export const useAuth = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAdminLogin = async (email, password, setError, setIsLoading) => {
    const data = { email, password }; 
    setIsLoading(true);
    setError(null);

    // console.log("login data", data);  
    try {
      const response = await LoginAdmin(email, password);
      localStorage.setItem("cookies", response.token);
      navigate("/users");
    } catch (error) {
      console.log("error", error);
      setError(error.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };
  

  return { handleAdminLogin, isLoading, error };
};
